import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./index.module.scss";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";

export default function SectionTitle({ backSrc, hasBackButton, ...props }) {
  const history = useHistory();

  const handleBack = () => {
    if (backSrc) {
      history.push(backSrc);
    } else {
      history.goBack();
    }
  };

  return (
    <div className={styles.container} {...props}>
      {(hasBackButton || backSrc) && (
        <span className={styles.backButton} onClick={handleBack}>
          <KeyboardArrowLeftIcon className={styles.icon} fontSize="inherit" />
        </span>
      )}

      <span className={styles.title}>{props.children}</span>
      {props.append ? (
        <span className={styles.append}>{props.append}</span>
      ) : (
        ""
      )}
    </div>
  );
}
